export const GET_CURRENT_SITUATION = 'GET_CURRENT_SITUATION';
export const LOADING_CURRENT_SITUATION = 'LOADING_CURRENT_SITUATION';
export const SAVE_LOADER_CURRENT_SITUATION='SAVE_LOADER_CURRENT_SITUATION';